/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';
import { Channel } from '../../common/types/types';

interface UpdateChannelAuthMutationProps {
    authOptions: object;
    channel: Channel;
}

export default class UpdateChannelAuthMutation extends Relay.Mutation<UpdateChannelAuthMutationProps> {

    static propTypes = {
        authOptions: PropTypes.object.isRequired,
        channel: PropTypes.object.isRequired,
    };

    static fragments = {
        channel: () => Relay.QL`
              fragment on Channel {
                    organisation_id,
                    id,
              }
            `,
    };

    getMutation() {
        return Relay.QL`mutation {updateChannelAuth}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on UpdateChannelAuthPayload {
                success,
                message
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            channel_id: this.props.channel.id,
            organisation_id: this.props.channel.organisation_id,
            authOptions: JSON.stringify(this.props.authOptions),
        };
    }
}
